import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { UUIDRegex } from 'common/constants/regex.constants';

export function ValidatePhone(c: UntypedFormControl) {
    const REGEXP = new RegExp(/^$|^\d{7}$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validPhone: true,
          };
}

export function ValidatePhoneSpace(c: UntypedFormControl) {
    const REGEXP = new RegExp(/^$|^\d{3}\s\d{4}$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validPhone: true,
          };
}

export function ValidateEmail(c: UntypedFormControl) {
    const REGEXP = new RegExp(
        /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    return REGEXP.test(c.value)
        ? null
        : {
              validEmail: true,
          };
}

export function ValidateApsUrl(c: UntypedFormControl) {
    const REGEXP = new RegExp(/^$|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/);
    return REGEXP.test(c.value)
        ? null
        : {
              validEmail: true,
          };
}

export function ValidateNumber(c: UntypedFormControl) {
    const REGEXP = new RegExp(/^\d+$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validNumber: true,
          };
}

export function ValidateKennitalaWithHyphen(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-3][0-9][0-1][0-9][0-9][0-9])[-]([0-9][0-9][0-9][0-9])$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validKennitalaWithHyphen: true,
          };
}

export function ValidateCompanyKennitalaWithHyphen(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-9][0-9][0-9][0-9][0-9][0-9])[-]([0-9][0-9][0-9][0-9])$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validCompanyKennitalaWithHyphen: true,
          };
}

export function ValidateCompanyKennitala(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validateCompanyKennitala: true,
          };
}

export function ValidateKennitala(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-3][0-9][0-1][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validKennitala: true,
          };
}

export function ValidateAnyKennitala(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-7][0-9][0-1][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validKennitala: true,
          };
}

export function ValidateHourMinutes(c: UntypedFormControl) {
    // tslint:disable-next-line:max-line-length
    const REGEXP = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validHourMinutes: true,
          };
}

export function ValidatePropertyNumber(c: UntypedFormControl) {
    const REGEXP = new RegExp(/F[1-9]{7}$/);
    return REGEXP.test(c.value)
        ? null
        : {
              validPropertyNumber: true,
          };
}

export function ValidateUUID(c: UntypedFormControl) {
    const REGEXP = new RegExp(UUIDRegex);
    return REGEXP.test(c.value)
        ? null
        : {
              validUUID: true,
          };
}

export function ValidateCoredataUrl(): ValidatorFn {
    return (control: AbstractControl) => {
        const value: string = control.value ?? '';
        if (!value) return null;
        const match = value.match(/\/doc\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i);
        return match ? null : { invalidCoredataUrl: true };
    };
}
